import { useI18n } from '../../lib/i18n';
import { StatCard } from '../ui/StatCard';
import { GoogleIcon } from '../icons/navIcons';
import { AlertTriangleIcon } from '../icons/uiIcons';
import { GoogleSheetsIcon, GoogleCalendarIcon } from './GoogleServiceIcons';
import type { GoogleAccountsStats } from '../../lib/google';

interface GoogleStatCardsProps {
  stats: GoogleAccountsStats;
  loading?: boolean;
}

export function GoogleStatCards({ stats, loading = false }: GoogleStatCardsProps) {
  const { t } = useI18n();

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 sm:gap-4">
      <StatCard
        label={t('google.stats.accounts') || 'Connected Accounts'}
        value={loading ? '—' : stats.accounts}
        variant="indigo"
        icon={<GoogleIcon size={18} />}
        caption={t('google.stats.accountsNote') || 'Active Google OAuth logins'}
      />
      <StatCard
        label={t('google.stats.sheetsAccess') || 'Sheets Access'}
        value={loading ? '—' : stats.sheetsAccess}
        variant="green"
        icon={<GoogleSheetsIcon size={18} />}
        caption={t('google.stats.sheetsNote') || 'Spreadsheets sync enabled'}
      />
      <StatCard
        label={t('google.stats.calendarAccess') || 'Calendar Access'}
        value={loading ? '—' : stats.calendarAccess}
        variant="sky"
        icon={<GoogleCalendarIcon size={18} />}
        caption={t('google.stats.calendarNote') || 'Events & Meet link sync'}
      />
      <StatCard
        label={t('google.stats.limitedAccess') || 'Limited Access'}
        value={loading ? '—' : stats.limitedAccess}
        variant={stats.limitedAccess > 0 ? 'amber' : 'slate'}
        icon={<AlertTriangleIcon size={18} />}
        caption={t('google.stats.limitedNote') || 'Accounts needing re-auth'}
      />
    </div>
  );
}
